import { render, staticRenderFns } from "./add-route.vue?vue&type=template&id=6e87cc28&scoped=true&"
import script from "./add-route.vue?vue&type=script&lang=js&"
export * from "./add-route.vue?vue&type=script&lang=js&"
import style0 from "./add-route.vue?vue&type=style&index=0&id=6e87cc28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e87cc28",
  null
  
)

export default component.exports